
export default {
    // English is defined as "root" to be used as fallback
    "root": {
      weekLetter:"W",
      sizeunit:{
        "B":" B",
        "KB":" KB",
        "MB":" MB",
        "GB":" GB",
        "TB":" TB"
      }
    },
    "fr": {
      weekLetter:"S",
      sizeunit: {
        "B": "o",
        "KB": "Ko",
        "MB": "Mo",
        "GB": "Go",
        "TB": "To"
      }
    },
    "es": {
      weekLetter:"S"
    },
    "de": {
      weekLetter:"W"
    },
    "pt": {
      weekLetter:"S"
    },
    "sq": {
      weekLetter:"J"
    },
    "nl": {
      weekLetter:"W"
    },
    "it":{
      weekLetter:"S"
    },
    "ja":{
      weekLetter:"週"
    },
    "ru":{
      weekLetter:"н",
      sizeunit: {
        "B": " Б",
        "KB": " КБ",
        "MB": " МБ",
        "GB": " ГБ",
        "TB": " ТБ"
      }
    },
    "ko":{
      weekLetter:"주"
    },
    "sv":{
      weekLetter:"V"
    }

  }

